// src/api/auth.js
import axios from 'axios';
import server, { BASE_URL } from './ApiUrls';



const authLogin = async (email: any, password: any, hospital_code: any,role:any) => {
    try {
        server.defaults.headers.common["hospitalcode"] = hospital_code;
        const response = await server.post('merchant/login', { email, password, hospital_code,role });
        // console.log(response);
        return response.data;
    } catch (error) {
        // Handle errors here
        console.error("Error occurred during login:", error);
        return error; // Re-throw the error to propagate it to the caller
    }
};

const authBranchLogin = async (email: any, password: any, hospital_code: any,branchId:any,role:any) => {
    try {
        server.defaults.headers.common["hospitalcode"] = hospital_code;
        const response = await server.post('merchant_branch/login', { email, password, hospital_code,branchId,role });
        // console.log(response);
        return response.data;
    } catch (error) {
        // Handle errors here
        console.error("Error occurred during login:", error);
        return error; // Re-throw the error to propagate it to the caller
    }
};



export { authLogin , authBranchLogin };
